import { createReducer, on } from '@ngrx/store';

import { environment } from '@app/environments/environment';
import Nullable from '@app/models/typescript/nullable.model';
import { SingleTenantConfig } from '@app/store/configs/single-tenant-config.type';
import { singleTenantActions } from '../actions/single-tenant.actions';

export type SingleTenantState = {
  isSingleTenant: boolean;
  config: Nullable<SingleTenantConfig>;
};

export const initialSingleTenantState: SingleTenantState = {
  isSingleTenant: environment.isSingleTenantApp,
  config: null,
};

export const singleTenantReducer = createReducer(
  initialSingleTenantState,
  on(
    singleTenantActions.configLoaded,
    (state, { config }): SingleTenantState => ({
      ...state,
      config,
    }),
  ),
);
